import type { TextStyleValue } from '@elfsight/configurator-contracts';

// https://www.figma.com/design/GM3rFfWwuIT4E3a3c78f57/%F0%9F%93%90-App-Library?node-id=877-2241&m=dev
const LINE_HEIGHT_MAP: Record<number, number> = {
  12: 14,
  13: 16,
  14: 18,
  15: 20,
  16: 22,
  17: 22,
  18: 24,
  19: 24,
  20: 26,
  22: 28,
  24: 30,
  28: 36,
  32: 40,
  36: 48
} as const;

const LARGE_LINE_HEIGHT = 1.25;
const LARGE_FONT_SIZE_THRESHOLD = 22;
export const DEFAULT_LINE_HEIGHT = 1.32;

export const getLineHeight = ({
  fontSize,
  lineHeight
}: Partial<TextStyleValue> = {}): string | number => {
  if (lineHeight) {
    return lineHeight;
  }

  if (!fontSize) {
    return DEFAULT_LINE_HEIGHT;
  }

  const mappedLineHeight = LINE_HEIGHT_MAP[fontSize];
  if (mappedLineHeight) {
    return `${mappedLineHeight}px`;
  }

  const calculatedValue =
    fontSize > LARGE_FONT_SIZE_THRESHOLD
      ? fontSize * LARGE_LINE_HEIGHT
      : fontSize * DEFAULT_LINE_HEIGHT;
  const evenValue = Math.floor(calculatedValue / 2) * 2;

  return `${evenValue}px`;
};
